export { AtnDsStepperItemComponent as Component } from './stepper-item.component'
